import React, { useState, useEffect, useRef, useMemo } from 'react'
import Layout from 'Layout'
import './styles.scss'
import { mixGetV1 } from 'services/mixin'
import { useLocation } from "react-router-dom";


const Openai: React.FC = () => {

  const [modelChatCat, setModelChatCat] = useState([])
  const [modelChat, setModelChat] = useState([])
  const { pathname } = useLocation();
  const slugCategories = pathname.split("/").pop();

  const getModelChat = async () => {
    const res = await mixGetV1(`/api/v1/fe/model_chats?model_chat_category_id=${currentCategory.id}`)

    if (res.status) {
      setModelChat(res.data.items)
    }
  }
  const getModelChatCat = async () => {
    const res = await mixGetV1(`/api/v1/fe/model_chat_categories`)

    if (res.status) {
      setModelChatCat(res.data.items)
    }
  }

  useEffect(() => {
    getModelChatCat()
  }, [])

  const currentCategory = useMemo(() => {
    return modelChatCat.find(item => item.slug === slugCategories);
  }, [modelChatCat, slugCategories]);

  useEffect(() => {
    if (currentCategory) {     // tránh undefined
      getModelChat()
    }
  }, [currentCategory])

  return (
    <Layout>
      <div id="lqd-titlebar" className="lqd-titlebar pt-6 pb-7 border-b transition-colors px-5 lg:px-10">
        <div className="lqd-titlebar-container flex flex-wrap items-center justify-between gap-y-4 container-fluid">
          <div className="lqd-titlebar-col lqd-titlebar-col-nav group/titlebar-nav flex w-full flex-col gap-2 lg:w-7/12">
            <p className="lqd-titlebar-pretitle text-xs text-foreground/70 m-0">
              <a
                className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button transition-all hover:-translate-y-0.5 hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-link bg-transparent hover:underline hover:transform-none hover:shadow-none focus-visible:underline p-0 focus-visible:translate-y-0 focus-visible:shadow-none focus-visible:outline-0 lqd-btn-size-none lqd-btn-hover-none text-inherit hover:text-foreground"
                href="/"
              >
                <svg stroke-width="1.5" className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M15 6l-6 6l6 6"></path>
                </svg>
                Back to dashboard
              </a>
            </p>
            <h1 className="lqd-titlebar-title m-0">
              AI Writer
            </h1>
            <p className="lqd-titlebar-subtitle mt-1 text-2xs opacity-80 only:my-0 last:mb-0">
              Text Generator &amp; AI Copywriting Assistant
            </p>
          </div>

          {/* <div className="lqd-titlebar-col lqd-titlebar-col-actions group/titlebar-actions flex w-full flex-wrap gap-y-3 max-lg:has-[.max-lg\:hidden:only-child]:hidden lg:w-5/12 lg:justify-end">
            <div className="lqd-titlebar-actions flex flex-wrap items-center gap-2">
              <a
                className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button transition-all hover:-translate-y-0.5 hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost-shadow bg-background text-foreground shadow-xs hover:bg-primary hover:text-primary-foreground dark:hover:bg-foreground dark:hover:text-background focus-visible:bg-primary focus-visible:text-primary-foreground dark:bg-foreground/[3%] dark:focus-visible:bg-foreground dark:focus-visible:text-background lqd-btn-md py-2 px-4 lqd-btn-hover-none mx-2"
                href="/"
              >
                My Documents
              </a>
              <a
                className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button transition-all hover:-translate-y-0.5 hover:shadow-xl disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-primary bg-primary text-primary-foreground hover:bg-primary/90 hover:shadow-primary/10 focus-visible:bg-primary/90 focus-visible:shadow-primary/10 lqd-btn-md py-2 px-4 lqd-btn-hover-none"
                href="https://demo.magicproject.ai/dashboard/user/openai/custom/add-or-update"
              >
                <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12 5l0 14"></path>
                  <path d="M5 12l14 0"></path>
                </svg>
                Create Template
              </a>
            </div>
          </div> */}

          {/* <div className="lqd-titlebar-after w-full">
            <ul className="lqd-filter-list mt-2 flex scroll-mt-6 flex-wrap items-center gap-x-4 gap-y-2 text-heading-foreground max-sm:gap-3" id="lqd-generators-filter-list">
              <li>
                <button
                  className="lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&amp;.active]:bg-foreground/5 active"
                  name="filter"
                  type="button"
                >
                  All
                </button>
              </li>
              <li>
                <button
                  className="lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&amp;.active]:bg-foreground/5"
                  type="button"
                >
                  Favorite
                </button>
              </li>

              <li>
                <button
                  className="lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&amp;.active]:bg-foreground/5"
                  type="button"
                >
                  Writer
                </button>
              </li>
              <li>
                <button
                  className="lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&amp;.active]:bg-foreground/5"
                  type="button"
                >
                  Website
                </button>
              </li>
              <li>
                <button
                  className="lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&amp;.active]:bg-foreground/5"
                  type="button"
                >
                  Social media
                </button>
              </li>
              <li>
                <button
                  className="lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&amp;.active]:bg-foreground/5"
                >
                  Misc
                </button>
              </li >
              <li>
                <button
                  className="lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&amp;.active]:bg-foreground/5"
                  type="button"
                >
                  Languages
                </button>
              </li>
              <li>
                <button
                  className="lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&amp;.active]:bg-foreground/5"
                  type="button"
                >
                  Fitness &amp; health
                </button>
              </li>
              <li>
                <button
                  className="lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&amp;.active]:bg-foreground/5"
                  type="button"
                >
                  Entertainment
                </button>
              </li>
              <li>
                <button
                  className="lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&amp;.active]:bg-foreground/5"
                  type="button"
                >
                  Email
                </button>
              </li>
              <li>
                <button
                  className="lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&amp;.active]:bg-foreground/5"
                  type="button"
                >
                  Ecommerce
                </button>
              </li>
              <li>
                <button
                  className="lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&amp;.active]:bg-foreground/5"
                  type="button"
                >
                  Development
                </button>
              </li>
              <li>
                <button
                  className="lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&amp;.active]:bg-foreground/5"
                  type="button"
                >
                  Customer service
                </button>
              </li>
              <li>
                <button
                  className="lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&amp;.active]:bg-foreground/5"
                  type="button"
                >
                  Business
                </button>
              </li >
              <li>
                <button
                  className="lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&amp;.active]:bg-foreground/5"
                  type="button"
                >
                  Blog
                </button>
              </li >
              <li>
                <button
                  className="lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&amp;.active]:bg-foreground/5"
                  type="button"
                >
                  Advertising
                </button>
              </li >
              <li>
                <button
                  className="lqd-btn group items-center justify-center gap-1.5 font-medium rounded-button hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost bg-transparent text-foreground focus-visible:bg-foreground/10 lqd-btn-md lqd-btn-hover-none lqd-filter-btn inline-flex px-2.5 py-0.5 text-2xs leading-tight transition-colors hover:translate-y-0 hover:bg-foreground/5 [&amp;.active]:bg-foreground/5"
                  type="button"
                >
                  Academic
                </button>
              </li >
            </ul >
          </div > */}
        </div >
      </div >

      <div className="lqd-page-content-container h-full container-fluid">
        <div className="lqd-generators-container" id="lqd-generators-container">
          <div className="lqd-generators-list grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" id="lqd-generators-list">
            {/* <div
              data-filter="ecommerce"
              className="lqd-card text-card-foreground bg-card-background transition-all lqd-card-outline border border-card-border rounded-card lqd-generator-item group relative w-full px-5 pb-10 pt-8 lg:px-10 2xl:px-16 border-t-0 border-s-0 border-b border-e"
            >
              <div className="lqd-card-body only:grow lqd-card-size-none static">
                <span
                  className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all text-primary-foreground [&amp;_svg]:max-w-full [&amp;_svg]:h-auto lqd-icon-xl size-11 lqd-generator-item-icon mb-5 bg-[--color] group-hover:scale-110 group-hover:shadow-lg"
                  style={{ ['--color' as any]: '#c2dedd' }}
                >
                  <span className="flex size-5 items-center justify-center transition-transform group-hover:scale-110">
                    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
                      <path d="M319 806h322v-60H319v60Zm0-170h322v-60H319v60Zm-99 340q-24 0-42-18t-18-42V236q0-24 18-42t42-18h361l219 219v521q0 24-18 42t-42 18H220Zm331-554h189L551 236v186Z"></path>
                    </svg>
                  </span>

                  <span className="absolute bottom-0 end-0 inline-block rounded-full border-2 border-background size-3 bg-green-500"></span>
                </span>
                <div className="lqd-generator-item-info">
                  <h4 className="relative mb-3.5 inline-block text-lg">
                    Product Description
                    <span className="absolute start-[calc(100%+0.35rem)]inline-block -translate-x-1 align-bottom opacity-0 transition-all group-hover:translate-x-0 group-hover:!opacity-100 rtl:-scale-x-100">
                      <svg className="size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M9 6l6 6l-6 6"></path>
                      </svg>
                    </span>
                  </h4>
                  <p className="m-0 opacity-85 text-xs">
                    Easily create compelling product descriptions that sell. Increase conversions and boost sales.
                  </p>
                </div>

                <div className="absolute left-0 top-0 z-2 h-full w-full transition-all bg-background/75">
                  <a className="absolute left-0 top-0 inline-block h-full w-full overflow-hidden flex items-center justify-center font-medium" href="https://demo.magicproject.ai/dashboard/user/payment">
                    <span className="inline-block rounded-md px-2 py-0.5 absolute end-4 top-4 bg-cyan-100 text-black">
                      Premium
                    </span>
                  </a>
                </div>
              </div>
            </div>
            <div
              className="lqd-card text-card-foreground bg-card-background transition-all lqd-card-outline border border-card-border rounded-card lqd-generator-item group relative w-full px-5 pb-10 pt-8 lg:px-10 2xl:px-16 border-t-0 border-s-0 border-b border-e"
            >
              <div className="lqd-card-body only:grow lqd-card-size-none static">
                <span
                  className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all text-primary-foreground [&amp;_svg]:max-w-full [&amp;_svg]:h-auto lqd-icon-xl size-11 lqd-generator-item-icon mb-5 bg-[--color] group-hover:scale-110 group-hover:shadow-lg"
                  style={{ ['--color' as any]: '#e2e5ff' }}
                >
                  <span className="flex size-5 items-center justify-center transition-transform group-hover:scale-110">
                    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
                      <path
                        d="M140 936q-24.75 0-42.375-17.625T80 876V216l67 67 66-67 67 67 67-67 66 67 67-67 67 67 66-67 67 67 67-67 66 67 67-67v660q0 24.75-17.625 42.375T820 936H140Zm0-60h310V596H140v280Zm370 0h310V766H510v110Zm0-170h310V596H510v110ZM140 536h680V416H140v120Z"
                      ></path>
                    </svg>
                  </span>

                  <span className="absolute bottom-0 end-0 inline-block rounded-full border-2 border-background size-3 bg-green-500"></span>
                </span>
                <div className="lqd-generator-item-info">
                  <h4 className="relative mb-3.5 inline-block text-lg">
                    Article Generator
                    <span className="absolute start-[calc(100%+0.35rem)] inline-block -translate-x-1 align-bottom opacity-0 transition-all group-hover:translate-x-0 group-hover:!opacity-100 rtl:-scale-x-100">
                      <svg className="size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M9 6l6 6l-6 6"></path>
                      </svg>
                    </span>
                  </h4>
                  <p className="m-0 opacity-85 text-xs">
                    Instantly create unique articles on any topic. Boost engagement, improve SEO, and save time.
                  </p>
                </div>

                <div className="absolute left-0 top-0 z-2 h-full w-full transition-all bg-background/75">
                  <a className="absolute left-0 top-0 inline-block h-full w-full overflow-hidden flex items-center justify-center font-medium" href="https://demo.magicproject.ai/dashboard/user/payment">
                    <span className="inline-block rounded-md px-2 py-0.5 absolute end-4 top-4 bg-cyan-100 text-black">
                      VIP
                    </span>
                  </a>
                </div>
              </div>
            </div>
            <div
              data-filter="ecommerce"
              className="lqd-card text-card-foreground bg-card-background transition-all lqd-card-outline border border-card-border rounded-card lqd-generator-item group relative w-full px-5 pb-10 pt-8 lg:px-10 2xl:px-16 border-t-0 border-s-0 border-b border-e"
            >
              <div className="lqd-card-body only:grow lqd-card-size-none static">
                <span
                  className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all text-primary-foreground [&_svg]:max-w-full [&_svg]:h-auto lqd-icon-xl size-11 lqd-generator-item-icon mb-5 bg-['#e2e5ff'] group-hover:scale-110 group-hover:shadow-lg"
                >
                  <span className="flex size-5 items-center justify-center transition-transform group-hover:scale-110">
                    <svg xmlns="http://www.w3.org/2000/svg" height="40" viewBox="0 96 960 960" width="40"><path d="m233 976 65-281L80 506l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Z"></path></svg>
                  </span>

                  <span className="absolute bottom-0 end-0 inline-block rounded-full border-2 border-background size-3 bg-green-500"></span>
                </span>
                <div className="lqd-generator-item-info">
                  <h4 className="relative mb-3.5 inline-block text-lg">
                    Testimonial Review
                    <span className="absolute start-[calc(100%+0.35rem)] inline-block -translate-x-1 align-bottom opacity-0 transition-all group-hover:translate-x-0 group-hover:!opacity-100 rtl:-scale-x-100">
                      <svg className="size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M9 6l6 6l-6 6"></path>
                      </svg>
                    </span>
                  </h4>
                  <p className="m-0 opacity-85 text-xs">
                    Instantly generate authentic testimonials. Build trust and credibility with genuine reviews.
                  </p>
                </div>

                <div className="absolute left-0 top-0 z-2 h-full w-full transition-all bg-background/75">
                  <a className="absolute left-0 top-0 inline-block h-full w-full overflow-hidden flex items-center justify-center font-medium" href="https://demo.magicproject.ai/dashboard/user/payment">
                    <span className="inline-block rounded-md px-2 py-0.5 absolute end-4 top-4 bg-cyan-100 text-black">
                      Enterprise
                    </span>
                  </a>
                </div>
              </div>
            </div>
            <div
              data-filter="blog"
              className="lqd-card text-card-foreground bg-card-background transition-all lqd-card-outline border border-card-border rounded-card lqd-generator-item group relative w-full px-5 pb-10 pt-8 lg:px-10 2xl:px-16 border-t-0 border-s-0 border-b border-e"
            >
              <div className="lqd-card-body only:grow lqd-card-size-none static">
                <span
                  className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all text-primary-foreground [&_svg]:max-w-full [&_svg]:h-auto lqd-icon-xl size-11 lqd-generator-item-icon mb-5 bg-['e2e5ff'] group-hover:scale-110 group-hover:shadow-lg"
                >
                  <span className="flex size-5 items-center justify-center transition-transform group-hover:scale-110">
                    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48"><path d="M80 236v-60h800v60H80Zm210 250V386h380v100H290Zm0 240V626h380v100H290Z"></path></svg>
                  </span>

                  <span className="absolute bottom-0 end-0 inline-block rounded-full border-2 border-background size-3 bg-green-500"></span>
                </span>
                <div className="lqd-generator-item-info">
                  <h4 className="relative mb-3.5 inline-block text-lg">
                    Blog Conclusion
                    <span className="absolute start-[calc(100%+0.35rem)] inline-block -translate-x-1 align-bottom opacity-0 transition-all group-hover:translate-x-0 group-hover:!opacity-100 rtl:-scale-x-100">
                      <svg className="size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M9 6l6 6l-6 6"></path>
                      </svg>
                    </span>
                  </h4>
                  <p className="m-0 opacity-85 text-xs">
                    End your blog posts on a high note. Craft memorable conclusions that leave a lasting impact.
                  </p>
                </div>

                <div className="absolute left-0 top-0 z-2 h-full w-full transition-all bg-background/75">
                  <a className="absolute left-0 top-0 inline-block h-full w-full overflow-hidden flex items-center justify-center font-medium" href="https://demo.magicproject.ai/dashboard/user/payment">
                    <span className="inline-block rounded-md px-2 py-0.5 absolute end-4 top-4 bg-cyan-100 text-black">
                      Pro
                    </span>
                  </a>
                </div>
              </div>
            </div> */}
            {modelChat.map((item, index) => (
              <div
                key={index}
                data-filter="social media"
                className="lqd-card text-card-foreground bg-card-background transition-all lqd-card-outline border border-card-border rounded-card lqd-generator-item group relative w-full px-5 pb-10 pt-8 lg:px-10 2xl:px-16 border-t-0 border-s-0 border-b border-e"
              >
                <div className="lqd-card-body only:grow lqd-card-size-none static">
                  <span
                    className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all text-primary-foreground [&amp;_svg]:max-w-full [&amp;_svg]:h-auto lqd-icon-xl size-11 lqd-generator-item-icon mb-5 bg-[--color] group-hover:scale-110 group-hover:shadow-lg"
                    // style={{ ['--color' as any]: '#e4cd9f' }}
                    style={{
                      ...(item.avatar
                        ? {
                          backgroundImage: `url(${item.avatar})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                        }
                        : {
                          ['--color' as any]: '#e4cd9f',
                        }
                      ),
                    }}
                  >
                    <span
                      className={item.avatar ? "flex size-5 items-center justify-center transition-transform group-hover:scale-110 d-none" : "flex size-5 items-center justify-center transition-transform group-hover:scale-110"}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48"><path d="M80 236v-60h800v60H80Zm210 250V386h380v100H290Zm0 240V626h380v100H290Z"></path></svg>
                    </span>

                    <span className="absolute bottom-0 end-0 inline-block rounded-full border-2 border-background size-3 bg-green-500"></span>
                  </span>
                  <div className="lqd-generator-item-info">
                    <h4 className="relative mb-3.5 inline-block text-lg">
                      {item.name}
                      <span className="absolute start-[calc(100%+0.35rem)] inline-block -translate-x-1 align-bottom opacity-0 transition-all group-hover:translate-x-0 group-hover:!opacity-100 rtl:-scale-x-100">
                        <svg className="size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M9 6l6 6l-6 6"></path>
                        </svg>
                      </span>
                    </h4>
                    <p className="m-0 opacity-85 text-xs">
                      {item.content}
                    </p>
                  </div>

                  <a
                    id="fav-btn-13"
                    title="Favorite"
                    className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button hover:-translate-y-0.5 hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost-shadow bg-background text-foreground shadow-xs hover:bg-primary hover:text-primary-foreground dark:hover:bg-foreground dark:hover:text-background focus-visible:bg-primary focus-visible:text-primary-foreground dark:bg-foreground/[3%] dark:focus-visible:bg-foreground dark:focus-visible:text-background lqd-btn-size-none lqd-btn-hover-none lqd-fav-btn z-10 size-9 absolute end-4 top-4 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                    href="#"
                  >
                    <span className="lqd-favorite-icon flex items-center justify-center w-4 h-4 group">
                      <svg
                        className="hidden h-full w-full group-[&amp;[data-is-active=true]]:block"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path
                          d="M8.243 7.34l-6.38 .925l-.113 .023a1 1 0 0 0 -.44 1.684l4.622 4.499l-1.09 6.355l-.013 .11a1 1 0 0 0 1.464 .944l5.706 -3l5.693 3l.1 .046a1 1 0 0 0 1.352 -1.1l-1.091 -6.355l4.624 -4.5l.078 -.085a1 1 0 0 0 -.633 -1.62l-6.38 -.926l-2.852 -5.78a1 1 0 0 0 -1.794 0l-2.853 5.78z"
                          stroke-width="0"
                          fill="currentColor"
                        ></path>
                      </svg>
                      <svg
                        className="h-full w-full group-[&amp;[data-is-active=true]]:hidden"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"></path>
                      </svg>
                    </span>
                  </a>

                  <div className="absolute left-0 top-0 z-2 h-full w-full transition-all">
                    <a className="absolute left-0 top-0 inline-block h-full w-full overflow-hidden -indent-[99999px]" href={`/user/openai/${item.slug}`}>
                      Create Workbook
                    </a>
                  </div>
                </div>
              </div>
            ))}
            {/* <div
              data-filter="social media"
              className="lqd-card text-card-foreground bg-card-background transition-all lqd-card-outline border border-card-border rounded-card lqd-generator-item group relative w-full px-5 pb-10 pt-8 lg:px-10 2xl:px-16 border-t-0 border-s-0 border-b border-e"
            >
              <div className="lqd-card-body only:grow lqd-card-size-none static">
                <span
                  className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all text-primary-foreground [&_svg]:max-w-full [&_svg]:h-auto lqd-icon-xl size-11 lqd-generator-item-icon mb-5 bg-[--color] group-hover:scale-110 group-hover:shadow-lg"
                  style={{ ['--color' as any]: '#e49fe1' }}
                >
                  <span className="flex size-5 items-center justify-center transition-transform group-hover:scale-110">
                    <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 24 24" id="instagram">
                      <path
                        d="M17.34,5.46h0a1.2,1.2,0,1,0,1.2,1.2A1.2,1.2,0,0,0,17.34,5.46Zm4.6,2.42a7.59,7.59,0,0,0-.46-2.43,4.94,4.94,0,0,0-1.16-1.77,4.7,4.7,0,0,0-1.77-1.15,7.3,7.3,0,0,0-2.43-.47C15.06,2,14.72,2,12,2s-3.06,0-4.12.06a7.3,7.3,0,0,0-2.43.47A4.78,4.78,0,0,0,3.68,3.68,4.7,4.7,0,0,0,2.53,5.45a7.3,7.3,0,0,0-.47,2.43C2,8.94,2,9.28,2,12s0,3.06.06,4.12a7.3,7.3,0,0,0,.47,2.43,4.7,4.7,0,0,0,1.15,1.77,4.78,4.78,0,0,0,1.77,1.15,7.3,7.3,0,0,0,2.43.47C8.94,22,9.28,22,12,22s3.06,0,4.12-.06a7.3,7.3,0,0,0,2.43-.47,4.7,4.7,0,0,0,1.77-1.15,4.85,4.85,0,0,0,1.16-1.77,7.59,7.59,0,0,0,.46-2.43c0-1.06.06-1.4.06-4.12S22,8.94,21.94,7.88ZM20.14,16a5.61,5.61,0,0,1-.34,1.86,3.06,3.06,0,0,1-.75,1.15,3.19,3.19,0,0,1-1.15.75,5.61,5.61,0,0,1-1.86.34c-1,.05-1.37.06-4,.06s-3,0-4-.06A5.73,5.73,0,0,1,6.1,19.8,3.27,3.27,0,0,1,5,19.05a3,3,0,0,1-.74-1.15A5.54,5.54,0,0,1,3.86,16c0-1-.06-1.37-.06-4s0-3,.06-4A5.54,5.54,0,0,1,4.21,6.1,3,3,0,0,1,5,5,3.14,3.14,0,0,1,6.1,4.2,5.73,5.73,0,0,1,8,3.86c1,0,1.37-.06,4-.06s3,0,4,.06a5.61,5.61,0,0,1,1.86.34A3.06,3.06,0,0,1,19.05,5,3.06,3.06,0,0,1,19.8,6.1,5.61,5.61,0,0,1,20.14,8c.05,1,.06,1.37.06,4S20.19,15,20.14,16ZM12,6.87A5.13,5.13,0,1,0,17.14,12,5.12,5.12,0,0,0,12,6.87Zm0,8.46A3.33,3.33,0,1,1,15.33,12,3.33,3.33,0,0,1,12,15.33Z"
                      ></path>
                    </svg>
                  </span>

                  <span className="absolute bottom-0 end-0 inline-block rounded-full border-2 border-background size-3 bg-green-500"></span>
                </span>
                <div className="lqd-generator-item-info">
                  <h4 className="relative mb-3.5 inline-block text-lg">
                    Instagram Captions
                    <span className="absolute start-[calc(100%+0.35rem)] inline-block -translate-x-1 align-bottom opacity-0 transition-all group-hover:translate-x-0 group-hover:!opacity-100 rtl:-scale-x-100">
                      <svg className="size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M9 6l6 6l-6 6"></path>
                      </svg>
                    </span>
                  </h4>
                  <p className="m-0 opacity-85 text-xs">
                    Elevate your Instagram game with captivating captions. Generate unique captions that engage followers and increase your reach.
                  </p>
                </div>

                <a
                  id="fav-btn-16"
                  title="Favorite"
                  className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button hover:-translate-y-0.5 hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost-shadow bg-background text-foreground shadow-xs hover:bg-primary hover:text-primary-foreground dark:hover:bg-foreground dark:hover:text-background focus-visible:bg-primary focus-visible:text-primary-foreground dark:bg-foreground/[3%] dark:focus-visible:bg-foreground dark:focus-visible:text-background lqd-btn-size-none lqd-btn-hover-none lqd-fav-btn z-10 size-9 absolute end-4 top-4 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                  href="#"
                >
                  <span className="lqd-favorite-icon flex items-center justify-center w-4 h-4 group">
                    <svg
                      className="hidden h-full w-full group-[&amp;[data-is-active=true]]:block"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path
                        d="M8.243 7.34l-6.38 .925l-.113 .023a1 1 0 0 0 -.44 1.684l4.622 4.499l-1.09 6.355l-.013 .11a1 1 0 0 0 1.464 .944l5.706 -3l5.693 3l.1 .046a1 1 0 0 0 1.352 -1.1l-1.091 -6.355l4.624 -4.5l.078 -.085a1 1 0 0 0 -.633 -1.62l-6.38 -.926l-2.852 -5.78a1 1 0 0 0 -1.794 0l-2.853 5.78z"
                        stroke-width="0"
                        fill="currentColor"
                      ></path>
                    </svg>
                    <svg
                      className="h-full w-full group-[&amp;[data-is-active=true]]:hidden"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"></path>
                    </svg>
                  </span>
                </a>

                <div className="absolute left-0 top-0 z-2 h-full w-full transition-all">
                  <a className="absolute left-0 top-0 inline-block h-full w-full overflow-hidden -indent-[99999px]" href="/user/openai/detail">
                    Create Workbook
                  </a>
                </div>
              </div>
            </div>
            <div
              data-filter="social media"
              className="lqd-card text-card-foreground bg-card-background transition-all lqd-card-outline border border-card-border rounded-card lqd-generator-item group relative w-full px-5 pb-10 pt-8 lg:px-10 2xl:px-16 border-t-0 border-s-0 border-b border-e"
            >
              <div className="lqd-card-body only:grow lqd-card-size-none static">
                <span
                  className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all text-primary-foreground [&_svg]:max-w-full [&_svg]:h-auto lqd-icon-xl size-11 lqd-generator-item-icon mb-5 bg-[--color] group-hover:scale-110 group-hover:shadow-lg"
                  style={{ ['--color' as any]: '#e49fe1' }}
                >
                  <span className="flex size-5 items-center justify-center transition-transform group-hover:scale-110">
                    <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 24 24" id="instagram">
                      <path
                        d="M17.34,5.46h0a1.2,1.2,0,1,0,1.2,1.2A1.2,1.2,0,0,0,17.34,5.46Zm4.6,2.42a7.59,7.59,0,0,0-.46-2.43,4.94,4.94,0,0,0-1.16-1.77,4.7,4.7,0,0,0-1.77-1.15,7.3,7.3,0,0,0-2.43-.47C15.06,2,14.72,2,12,2s-3.06,0-4.12.06a7.3,7.3,0,0,0-2.43.47A4.78,4.78,0,0,0,3.68,3.68,4.7,4.7,0,0,0,2.53,5.45a7.3,7.3,0,0,0-.47,2.43C2,8.94,2,9.28,2,12s0,3.06.06,4.12a7.3,7.3,0,0,0,.47,2.43,4.7,4.7,0,0,0,1.15,1.77,4.78,4.78,0,0,0,1.77,1.15,7.3,7.3,0,0,0,2.43.47C8.94,22,9.28,22,12,22s3.06,0,4.12-.06a7.3,7.3,0,0,0,2.43-.47,4.7,4.7,0,0,0,1.77-1.15,4.85,4.85,0,0,0,1.16-1.77,7.59,7.59,0,0,0,.46-2.43c0-1.06.06-1.4.06-4.12S22,8.94,21.94,7.88ZM20.14,16a5.61,5.61,0,0,1-.34,1.86,3.06,3.06,0,0,1-.75,1.15,3.19,3.19,0,0,1-1.15.75,5.61,5.61,0,0,1-1.86.34c-1,.05-1.37.06-4,.06s-3,0-4-.06A5.73,5.73,0,0,1,6.1,19.8,3.27,3.27,0,0,1,5,19.05a3,3,0,0,1-.74-1.15A5.54,5.54,0,0,1,3.86,16c0-1-.06-1.37-.06-4s0-3,.06-4A5.54,5.54,0,0,1,4.21,6.1,3,3,0,0,1,5,5,3.14,3.14,0,0,1,6.1,4.2,5.73,5.73,0,0,1,8,3.86c1,0,1.37-.06,4-.06s3,0,4,.06a5.61,5.61,0,0,1,1.86.34A3.06,3.06,0,0,1,19.05,5,3.06,3.06,0,0,1,19.8,6.1,5.61,5.61,0,0,1,20.14,8c.05,1,.06,1.37.06,4S20.19,15,20.14,16ZM12,6.87A5.13,5.13,0,1,0,17.14,12,5.12,5.12,0,0,0,12,6.87Zm0,8.46A3.33,3.33,0,1,1,15.33,12,3.33,3.33,0,0,1,12,15.33Z"
                      ></path>
                    </svg>
                  </span>

                  <span className="absolute bottom-0 end-0 inline-block rounded-full border-2 border-background size-3 bg-green-500"></span>
                </span>
                <div className="lqd-generator-item-info">
                  <h4 className="relative mb-3.5 inline-block text-lg">
                    Instagram Hashtags
                    <span className="absolute start-[calc(100%+0.35rem)] inline-block -translate-x-1 align-bottom opacity-0 transition-all group-hover:translate-x-0 group-hover:!opacity-100 rtl:-scale-x-100">
                      <svg className="size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M9 6l6 6l-6 6"></path>
                      </svg>
                    </span>
                  </h4>
                  <p className="m-0 opacity-85 text-xs">
                    Boost your Instagram reach with relevant hashtags. Generate optimal, trending hashtags and increase your visibility.
                  </p>
                </div>

                <a
                  id="fav-btn-17"
                  title="Favorite"
                  className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button hover:-translate-y-0.5 hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost-shadow bg-background text-foreground shadow-xs hover:bg-primary hover:text-primary-foreground dark:hover:bg-foreground dark:hover:text-background focus-visible:bg-primary focus-visible:text-primary-foreground dark:bg-foreground/[3%] dark:focus-visible:bg-foreground dark:focus-visible:text-background lqd-btn-size-none lqd-btn-hover-none lqd-fav-btn z-10 size-9 absolute end-4 top-4 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                  href="#"
                >
                  <span className="lqd-favorite-icon flex items-center justify-center w-4 h-4 group">
                    <svg
                      className="hidden h-full w-full group-[&amp;[data-is-active=true]]:block"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path
                        d="M8.243 7.34l-6.38 .925l-.113 .023a1 1 0 0 0 -.44 1.684l4.622 4.499l-1.09 6.355l-.013 .11a1 1 0 0 0 1.464 .944l5.706 -3l5.693 3l.1 .046a1 1 0 0 0 1.352 -1.1l-1.091 -6.355l4.624 -4.5l.078 -.085a1 1 0 0 0 -.633 -1.62l-6.38 -.926l-2.852 -5.78a1 1 0 0 0 -1.794 0l-2.853 5.78z"
                        stroke-width="0"
                        fill="currentColor"
                      ></path>
                    </svg>
                    <svg
                      className="h-full w-full group-[&amp;[data-is-active=true]]:hidden"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"></path>
                    </svg>
                  </span>
                </a>

                <div className="absolute left-0 top-0 z-2 h-full w-full transition-all">
                  <a className="absolute left-0 top-0 inline-block h-full w-full overflow-hidden -indent-[99999px]" href="/user/openai/detail">
                    Create Workbook
                  </a>
                </div>
              </div>
            </div>
            <div
              data-filter="social media"
              className="lqd-card text-card-foreground bg-card-background transition-all lqd-card-outline border border-card-border rounded-card lqd-generator-item group relative w-full px-5 pb-10 pt-8 lg:px-10 2xl:px-16 border-t-0 border-s-0 border-b border-e"
            >
              <div className="lqd-card-body only:grow lqd-card-size-none static">
                <span
                  className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all text-primary-foreground [&amp;_svg]:max-w-full [&amp;_svg]:h-auto lqd-icon-xl size-11 lqd-generator-item-icon mb-5 bg-[--color] group-hover:scale-110 group-hover:shadow-lg"
                  style={{ ['--color' as any]: '#c2dede' }}
                >
                  <span className="flex size-5 items-center justify-center transition-transform group-hover:scale-110">
                    <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 24 24" id="twitter">
                      <path
                        d="M22,5.8a8.49,8.49,0,0,1-2.36.64,4.13,4.13,0,0,0,1.81-2.27,8.21,8.21,0,0,1-2.61,1,4.1,4.1,0,0,0-7,3.74A11.64,11.64,0,0,1,3.39,4.62a4.16,4.16,0,0,0-.55,2.07A4.09,4.09,0,0,0,4.66,10.1,4.05,4.05,0,0,1,2.8,9.59v.05a4.1,4.1,0,0,0,3.3,4A3.93,3.93,0,0,1,5,13.81a4.9,4.9,0,0,1-.77-.07,4.11,4.11,0,0,0,3.83,2.84A8.22,8.22,0,0,1,3,18.34a7.93,7.93,0,0,1-1-.06,11.57,11.57,0,0,0,6.29,1.85A11.59,11.59,0,0,0,20,8.45c0-.17,0-.35,0-.53A8.43,8.43,0,0,0,22,5.8Z"
                      ></path>
                    </svg>
                  </span>

                  <span className="absolute bottom-0 end-0 inline-block rounded-full border-2 border-background size-3 bg-green-500"></span>
                </span>
                <div className="lqd-generator-item-info">
                  <h4 className="relative mb-3.5 inline-block text-lg">
                    Social Media Post Tweet
                    <span className="absolute start-[calc(100%+0.35rem)] inline-block -translate-x-1 align-bottom opacity-0 transition-all group-hover:translate-x-0 group-hover:!opacity-100 rtl:-scale-x-100">
                      <svg className="size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M9 6l6 6l-6 6"></path>
                      </svg>
                    </span>
                  </h4>
                  <p className="m-0 opacity-85 text-xs">
                    Make an impact with every tweet. Generate attention-grabbing social media posts and increase engagement.
                  </p>
                </div>

                <a
                  id="fav-btn-18"
                  title="Favorite"
                  className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button hover:-translate-y-0.5 hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost-shadow bg-background text-foreground shadow-xs hover:bg-primary hover:text-primary-foreground dark:hover:bg-foreground dark:hover:text-background focus-visible:bg-primary focus-visible:text-primary-foreground dark:bg-foreground/[3%] dark:focus-visible:bg-foreground dark:focus-visible:text-background lqd-btn-size-none lqd-btn-hover-none lqd-fav-btn z-10 size-9 absolute end-4 top-4 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                  href="#"
                >
                  <span className="lqd-favorite-icon flex items-center justify-center w-4 h-4 group">
                    <svg
                      className="hidden h-full w-full group-[&amp;[data-is-active=true]]:block"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path
                        d="M8.243 7.34l-6.38 .925l-.113 .023a1 1 0 0 0 -.44 1.684l4.622 4.499l-1.09 6.355l-.013 .11a1 1 0 0 0 1.464 .944l5.706 -3l5.693 3l.1 .046a1 1 0 0 0 1.352 -1.1l-1.091 -6.355l4.624 -4.5l.078 -.085a1 1 0 0 0 -.633 -1.62l-6.38 -.926l-2.852 -5.78a1 1 0 0 0 -1.794 0l-2.853 5.78z"
                        stroke-width="0"
                        fill="currentColor"
                      ></path>
                    </svg>
                    <svg
                      className="h-full w-full group-[&amp;[data-is-active=true]]:hidden"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"></path>
                    </svg>
                  </span>
                </a>

                <div className="absolute left-0 top-0 z-2 h-full w-full transition-all">
                  <a className="absolute left-0 top-0 inline-block h-full w-full overflow-hidden -indent-[99999px]" href="/user/openai/detail">
                    Create Workbook
                  </a>
                </div>
              </div>
            </div>
            <div
              data-filter="social media"
              className="lqd-card text-card-foreground bg-card-background transition-all lqd-card-outline border border-card-border rounded-card lqd-generator-item group relative w-full px-5 pb-10 pt-8 lg:px-10 2xl:px-16 border-t-0 border-s-0 border-b border-e"
            >
              <div className="lqd-card-body only:grow lqd-card-size-none static">
                <span
                  className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all text-primary-foreground [&_svg]:max-w-full [&_svg]:h-auto lqd-icon-xl size-11 lqd-generator-item-icon mb-5 bg-[--color] group-hover:scale-110 group-hover:shadow-lg"
                  style={{ ['--color' as any]: '#e3e49f' }}
                >
                  <span className="flex size-5 items-center justify-center transition-transform group-hover:scale-110">
                    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
                      <path d="M180 936q-24 0-42-18t-18-42V276q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm100-160h200v-80H280v80Zm40-171 160-80 160 80V276H320v329Z"></path>
                    </svg>
                  </span>

                  <span className="absolute bottom-0 end-0 inline-block rounded-full border-2 border-background size-3 bg-green-500"></span>
                </span>
                <div className="lqd-generator-item-info">
                  <h4 className="relative mb-3.5 inline-block text-lg">
                    Social Media Post Business
                    <span className="absolute start-[calc(100%+0.35rem)] inline-block -translate-x-1 align-bottom opacity-0 transition-all group-hover:translate-x-0 group-hover:!opacity-100 rtl:-scale-x-100">
                      <svg className="size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M9 6l6 6l-6 6"></path>
                      </svg>
                    </span>
                  </h4>
                  <p className="m-0 opacity-85 text-xs">
                    Generate a text for your business social media networks. Maximize your social media presence with impactful business posts.
                  </p>
                </div>

                <a
                  id="fav-btn-19"
                  title="Favorite"
                  className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button hover:-translate-y-0.5 hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost-shadow bg-background text-foreground shadow-xs hover:bg-primary hover:text-primary-foreground dark:hover:bg-foreground dark:hover:text-background focus-visible:bg-primary focus-visible:text-primary-foreground dark:bg-foreground/[3%] dark:focus-visible:bg-foreground dark:focus-visible:text-background lqd-btn-size-none lqd-btn-hover-none lqd-fav-btn z-10 size-9 absolute end-4 top-4 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                  href="#"
                >
                  <span className="lqd-favorite-icon flex items-center justify-center w-4 h-4 group">
                    <svg
                      className="hidden h-full w-full group-[&amp;[data-is-active=true]]:block"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path
                        d="M8.243 7.34l-6.38 .925l-.113 .023a1 1 0 0 0 -.44 1.684l4.622 4.499l-1.09 6.355l-.013 .11a1 1 0 0 0 1.464 .944l5.706 -3l5.693 3l.1 .046a1 1 0 0 0 1.352 -1.1l-1.091 -6.355l4.624 -4.5l.078 -.085a1 1 0 0 0 -.633 -1.62l-6.38 -.926l-2.852 -5.78a1 1 0 0 0 -1.794 0l-2.853 5.78z"
                        stroke-width="0"
                        fill="currentColor"
                      ></path>
                    </svg>
                    <svg
                      className="h-full w-full group-[&amp;[data-is-active=true]]:hidden"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"></path>
                    </svg>
                  </span>
                </a>

                <div className="absolute left-0 top-0 z-2 h-full w-full transition-all">
                  <a className="absolute left-0 top-0 inline-block h-full w-full overflow-hidden -indent-[99999px]" href="/user/openai/detail">
                    Create Workbook
                  </a>
                </div>
              </div>
            </div>
            <div
              data-filter="social media"
              className="lqd-card text-card-foreground bg-card-background transition-all lqd-card-outline border border-card-border rounded-card lqd-generator-item group relative w-full px-5 pb-10 pt-8 lg:px-10 2xl:px-16 border-t-0 border-s-0 border-b border-e"
            >
              <div className="lqd-card-body only:grow lqd-card-size-none static">
                <span
                  className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all text-primary-foreground [&_svg]:max-w-full [&_svg]:h-auto lqd-icon-xl size-11 lqd-generator-item-icon mb-5 bg-[--color] group-hover:scale-110 group-hover:shadow-lg"
                  style={{ ['--color' as any]: '#e8cec3' }}
                >
                  <span className="flex size-5 items-center justify-center transition-transform group-hover:scale-110">
                    <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.66016 15.2383H2.88281V8.41797H0.5625V5.74609H2.88281V3.77734C2.88281 2.65234 3.19922 1.78516 3.83203 1.17578C4.46484 0.566406 5.30859 0.261719 6.36328 0.261719C7.20703 0.261719 7.89844 0.296875 8.4375 0.367188V2.72266L6.99609 2.75781C6.48047 2.75781 6.12891 2.86328 5.94141 3.07422C5.75391 3.28516 5.66016 3.60156 5.66016 4.02344V5.74609H8.33203L7.98047 8.41797H5.66016V15.2383Z"
                        fill="#23344D"
                      ></path>
                    </svg>
                  </span>

                  <span className="absolute bottom-0 end-0 inline-block rounded-full border-2 border-background size-3 bg-green-500"></span>
                </span>
                <div className="lqd-generator-item-info">
                  <h4 className="relative mb-3.5 inline-block text-lg">
                    Facebook Headlines
                    <span className="absolute start-[calc(100%+0.35rem)] inline-block -translate-x-1 align-bottom opacity-0 transition-all group-hover:translate-x-0 group-hover:!opacity-100 rtl:-scale-x-100">
                      <svg className="size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M9 6l6 6l-6 6"></path>
                      </svg>
                    </span>
                  </h4>
                  <p className="m-0 opacity-85 text-xs">
                    Get noticed with attention-grabbing Facebook headlines. Generate unique, clickable headlines that increase engagement and drive traffic.
                  </p>
                </div>

                <a
                  id="fav-btn-20"
                  title="Favorite"
                  className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button hover:-translate-y-0.5 hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost-shadow bg-background text-foreground shadow-xs hover:bg-primary hover:text-primary-foreground dark:hover:bg-foreground dark:hover:text-background focus-visible:bg-primary focus-visible:text-primary-foreground dark:bg-foreground/[3%] dark:focus-visible:bg-foreground dark:focus-visible:text-background lqd-btn-size-none lqd-btn-hover-none lqd-fav-btn z-10 size-9 absolute end-4 top-4 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                  href="#"
                >
                  <span className="lqd-favorite-icon flex items-center justify-center w-4 h-4 group">
                    <svg
                      className="hidden h-full w-full group-[&amp;[data-is-active=true]]:block"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path
                        d="M8.243 7.34l-6.38 .925l-.113 .023a1 1 0 0 0 -.44 1.684l4.622 4.499l-1.09 6.355l-.013 .11a1 1 0 0 0 1.464 .944l5.706 -3l5.693 3l.1 .046a1 1 0 0 0 1.352 -1.1l-1.091 -6.355l4.624 -4.5l.078 -.085a1 1 0 0 0 -.633 -1.62l-6.38 -.926l-2.852 -5.78a1 1 0 0 0 -1.794 0l-2.853 5.78z"
                        stroke-width="0"
                        fill="currentColor"
                      ></path>
                    </svg>
                    <svg
                      className="h-full w-full group-[&amp;[data-is-active=true]]:hidden"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"></path>
                    </svg>
                  </span>
                </a>

                <div className="absolute left-0 top-0 z-2 h-full w-full transition-all">
                  <a className="absolute left-0 top-0 inline-block h-full w-full overflow-hidden -indent-[99999px]" href="/user/openai/detail">
                    Create Workbook
                  </a>
                </div>
              </div>
            </div>
            <div
              data-filter="advertisement"
              className="lqd-card text-card-foreground bg-card-background transition-all lqd-card-outline border border-card-border rounded-card lqd-generator-item group relative w-full px-5 pb-10 pt-8 lg:px-10 2xl:px-16 border-t-0 border-s-0 border-b border-e"
            >
              <div className="lqd-card-body only:grow lqd-card-size-none static">
                <span
                  className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all text-primary-foreground [&_svg]:max-w-full [&_svg]:h-auto lqd-icon-xl size-11 lqd-generator-item-icon mb-5 bg-[--color] group-hover:scale-110 group-hover:shadow-lg"
                  style={{ ['--color' as any]: '#d6c0a3' }}
                >
                  <span className="flex size-5 items-center justify-center transition-transform group-hover:scale-110">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" enable-background="new 0 0 32 32" viewBox="0 0 32 32" id="adwords">
                      <path
                        fill="#263238"
                        d="M2.066 23.314c-.082 0-.166-.021-.242-.063-.242-.135-.329-.438-.194-.681L9.278 8.803c.134-.24.439-.326.68-.194.242.135.329.438.194.681L2.503 23.058C2.412 23.222 2.242 23.314 2.066 23.314zM9.933 27.686c-.082 0-.166-.021-.242-.063-.242-.135-.329-.438-.194-.681l4.796-8.634c.133-.24.438-.326.68-.194.242.135.329.438.194.681l-4.796 8.634C10.279 27.593 10.109 27.686 9.933 27.686z"
                      ></path>
                      <path
                        fill="#263238"
                        d="M15.709,15.761L9.497,26.942c-0.705,1.27-2.046,2.059-3.5,2.059c-0.674,0-1.345-0.175-1.939-0.505 c-1.928-1.07-2.625-3.511-1.554-5.438l7.578-13.639c0.134-0.241,0.047-0.546-0.194-0.681c-0.24-0.133-0.545-0.046-0.68,0.194 L1.629,22.571c-1.339,2.41-0.468,5.46,1.942,6.8c0.742,0.412,1.58,0.63,2.424,0.63c1.817,0,3.493-0.985,4.375-2.572 l5.921-10.658L15.709,15.761z"
                      ></path>
                      <path
                        fill="#263238"
                        d="M6 30c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5S8.757 30 6 30zM6 21c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4S8.206 21 6 21zM26.004 30.001c-1.817 0-3.493-.985-4.375-2.572l-10-18c-1.339-2.41-.468-5.46 1.942-6.8.742-.412 1.581-.631 2.425-.631 1.816 0 3.492.986 4.374 2.573l10 18c1.339 2.41.468 5.46-1.942 6.8C27.687 29.783 26.848 30.001 26.004 30.001zM15.997 2.998c-.675 0-1.345.175-1.94.506-1.928 1.07-2.625 3.511-1.554 5.438l10 18c.705 1.27 2.046 2.059 3.5 2.059.674 0 1.345-.175 1.939-.505 1.928-1.07 2.625-3.511 1.554-5.438l-10-18C18.792 3.787 17.451 2.998 15.997 2.998z"
                      ></path>
                    </svg>
                  </span>

                  <span className="absolute bottom-0 end-0 inline-block rounded-full border-2 border-background size-3 bg-green-500"></span>
                </span>
                <div className="lqd-generator-item-info">
                  <h4 className="relative mb-3.5 inline-block text-lg">
                    Google Ads Headlines
                    <span className="absolute start-[calc(100%+0.35rem)] inline-block -translate-x-1 align-bottom opacity-0 transition-all group-hover:translate-x-0 group-hover:!opacity-100 rtl:-scale-x-100">
                      <svg className="size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M9 6l6 6l-6 6"></path>
                      </svg>
                    </span>
                  </h4>
                  <p className="m-0 opacity-85 text-xs">
                    Create high-converting Google ads with captivating headlines. Generate unique, clickable ads that drive traffic and boost sales.
                  </p>
                </div>

                <a
                  id="fav-btn-21"
                  title="Favorite"
                  className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button hover:-translate-y-0.5 hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost-shadow bg-background text-foreground shadow-xs hover:bg-primary hover:text-primary-foreground dark:hover:bg-foreground dark:hover:text-background focus-visible:bg-primary focus-visible:text-primary-foreground dark:bg-foreground/[3%] dark:focus-visible:bg-foreground dark:focus-visible:text-background lqd-btn-size-none lqd-btn-hover-none lqd-fav-btn z-10 size-9 absolute end-4 top-4 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                  href="#"
                >
                  <span className="lqd-favorite-icon flex items-center justify-center w-4 h-4 group">
                    <svg
                      className="hidden h-full w-full group-[&amp;[data-is-active=true]]:block"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path
                        d="M8.243 7.34l-6.38 .925l-.113 .023a1 1 0 0 0 -.44 1.684l4.622 4.499l-1.09 6.355l-.013 .11a1 1 0 0 0 1.464 .944l5.706 -3l5.693 3l.1 .046a1 1 0 0 0 1.352 -1.1l-1.091 -6.355l4.624 -4.5l.078 -.085a1 1 0 0 0 -.633 -1.62l-6.38 -.926l-2.852 -5.78a1 1 0 0 0 -1.794 0l-2.853 5.78z"
                        stroke-width="0"
                        fill="currentColor"
                      ></path>
                    </svg>
                    <svg
                      className="h-full w-full group-[&amp;[data-is-active=true]]:hidden"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"></path>
                    </svg>
                  </span>
                </a>

                <div className="absolute left-0 top-0 z-2 h-full w-full transition-all">
                  <a className="absolute left-0 top-0 inline-block h-full w-full overflow-hidden -indent-[99999px]" href="/user/openai/detail">
                    Create Workbook
                  </a>
                </div>
              </div>
            </div>
            <div
              data-filter="advertising"
              className="lqd-card text-card-foreground bg-card-background transition-all lqd-card-outline border border-card-border rounded-card lqd-generator-item group relative w-full px-5 pb-10 pt-8 lg:px-10 2xl:px-16 border-t-0 border-s-0 border-b border-e"
            >
              <div className="lqd-card-body only:grow lqd-card-size-none static">
                <span
                  className="lqd-icon flex items-center justify-center shrink-0 relative shadow-xs rounded-full transition-all text-primary-foreground [&_svg]:max-w-full [&_svg]:h-auto lqd-icon-xl size-11 lqd-generator-item-icon mb-5 bg-[--color] group-hover:scale-110 group-hover:shadow-lg"
                  style={{ ['--color' as any]: '#d6c0a3' }}
                >
                  <span className="flex size-5 items-center justify-center transition-transform group-hover:scale-110">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" enable-background="new 0 0 32 32" viewBox="0 0 32 32" id="adwords">
                      <path
                        fill="#263238"
                        d="M2.066 23.314c-.082 0-.166-.021-.242-.063-.242-.135-.329-.438-.194-.681L9.278 8.803c.134-.24.439-.326.68-.194.242.135.329.438.194.681L2.503 23.058C2.412 23.222 2.242 23.314 2.066 23.314zM9.933 27.686c-.082 0-.166-.021-.242-.063-.242-.135-.329-.438-.194-.681l4.796-8.634c.133-.24.438-.326.68-.194.242.135.329.438.194.681l-4.796 8.634C10.279 27.593 10.109 27.686 9.933 27.686z"
                      ></path>
                      <path
                        fill="#263238"
                        d="M15.709,15.761L9.497,26.942c-0.705,1.27-2.046,2.059-3.5,2.059c-0.674,0-1.345-0.175-1.939-0.505 c-1.928-1.07-2.625-3.511-1.554-5.438l7.578-13.639c0.134-0.241,0.047-0.546-0.194-0.681c-0.24-0.133-0.545-0.046-0.68,0.194 L1.629,22.571c-1.339,2.41-0.468,5.46,1.942,6.8c0.742,0.412,1.58,0.63,2.424,0.63c1.817,0,3.493-0.985,4.375-2.572 l5.921-10.658L15.709,15.761z"
                      ></path>
                      <path
                        fill="#263238"
                        d="M6 30c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5S8.757 30 6 30zM6 21c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4S8.206 21 6 21zM26.004 30.001c-1.817 0-3.493-.985-4.375-2.572l-10-18c-1.339-2.41-.468-5.46 1.942-6.8.742-.412 1.581-.631 2.425-.631 1.816 0 3.492.986 4.374 2.573l10 18c1.339 2.41.468 5.46-1.942 6.8C27.687 29.783 26.848 30.001 26.004 30.001zM15.997 2.998c-.675 0-1.345.175-1.94.506-1.928 1.07-2.625 3.511-1.554 5.438l10 18c.705 1.27 2.046 2.059 3.5 2.059.674 0 1.345-.175 1.939-.505 1.928-1.07 2.625-3.511 1.554-5.438l-10-18C18.792 3.787 17.451 2.998 15.997 2.998z"
                      ></path>
                    </svg>
                  </span>

                  <span className="absolute bottom-0 end-0 inline-block rounded-full border-2 border-background size-3 bg-green-500"></span>
                </span>
                <div className="lqd-generator-item-info">
                  <h4 className="relative mb-3.5 inline-block text-lg">
                    Google Ads Description
                    <span className="absolute start-[calc(100%+0.35rem)] inline-block -translate-x-1 align-bottom opacity-0 transition-all group-hover:translate-x-0 group-hover:!opacity-100 rtl:-scale-x-100">
                      <svg className="size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M9 6l6 6l-6 6"></path>
                      </svg>
                    </span>
                  </h4>
                  <p className="m-0 opacity-85 text-xs">
                    Step up your Google ad game, Craft high-converting ad copy that grabs attention and drives sales.
                  </p>
                </div>

                <button
                  id="fav-btn-23"
                  title="Favorite"
                  className="lqd-btn group inline-flex items-center justify-center gap-1.5 text-xs font-medium rounded-button hover:-translate-y-0.5 hover:shadow-xl hover:shadow-black/5 disabled:bg-foreground/10 disabled:text-foreground/35 disabled:pointer-events-none lqd-btn-ghost-shadow bg-background text-foreground shadow-xs hover:bg-primary hover:text-primary-foreground dark:hover:bg-foreground dark:hover:text-background focus-visible:bg-primary focus-visible:text-primary-foreground dark:bg-foreground/[3%] dark:focus-visible:bg-foreground dark:focus-visible:text-background lqd-btn-size-none lqd-btn-hover-none lqd-fav-btn z-10 size-9 absolute end-4 top-4 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                  type="button"
                >
                  <span className="lqd-favorite-icon flex items-center justify-center w-4 h-4 group">
                    <svg
                      className="hidden h-full w-full group-[&amp;[data-is-active=true]]:block"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path
                        d="M8.243 7.34l-6.38 .925l-.113 .023a1 1 0 0 0 -.44 1.684l4.622 4.499l-1.09 6.355l-.013 .11a1 1 0 0 0 1.464 .944l5.706 -3l5.693 3l.1 .046a1 1 0 0 0 1.352 -1.1l-1.091 -6.355l4.624 -4.5l.078 -.085a1 1 0 0 0 -.633 -1.62l-6.38 -.926l-2.852 -5.78a1 1 0 0 0 -1.794 0l-2.853 5.78z"
                        stroke-width="0"
                        fill="currentColor"
                      ></path>
                    </svg>
                    <svg
                      className="h-full w-full group-[&amp;[data-is-active=true]]:hidden"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"></path>
                    </svg>
                  </span>
                </button>

                <div className="absolute left-0 top-0 z-2 h-full w-full transition-all">
                  <a className="absolute left-0 top-0 inline-block h-full w-full overflow-hidden -indent-[99999px]" href="/user/openai/detail">
                    Create Workbook
                  </a>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>

    </Layout >
  )
}

export default Openai
